import { LottieBase, LottieProps } from './lottie-base';

const animationJSON = {
  nm: 'Main Scene',
  ddd: 0,
  h: 48,
  w: 48,
  meta: { g: '@lottiefiles/creator 1.46.0' },
  layers: [
    {
      ty: 4,
      nm: 'Vector',
      sr: 1,
      st: 0,
      op: 120,
      ip: 0,
      hd: false,
      ddd: 0,
      bm: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [24, 24] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [24, 24] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: 'sh',
          bm: 0,
          hd: false,
          nm: 'Path 1',
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [4.02, 0],
                [3.36, -1.74],
                [0, -9.24],
                [-7.68, -4.02],
                [-4.02, 0],
                [-3.36, 1.74],
                [0, 9.24],
                [7.62, 4.02],
              ],
              o: [
                [-3.36, -1.74],
                [-4.02, 0],
                [-7.62, 4.02],
                [0, 9.24],
                [3.3, 1.68],
                [4.02, 0],
                [7.68, -3.96],
                [0, -9.24],
                [0, 0],
              ],
              v: [
                [35.16, 2.7],
                [24, 0],
                [12.84, 2.7],
                [0, 24],
                [12.9, 45.3],
                [24, 48],
                [35.1, 45.24],
                [48, 24],
                [35.16, 2.7],
              ],
            },
          },
        },
        {
          ty: 'sh',
          bm: 0,
          hd: false,
          nm: 'Path 2',
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [-6.3, 3.84],
                [-3.9, 0.12],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 3.72],
              ],
              o: [
                [0, -7.86],
                [3.06, -1.86],
                [0, 0],
                [0, 0],
                [0, 0],
                [-1.62, -3.06],
                [0, 0],
              ],
              v: [
                [2.4, 24],
                [12.9, 5.46],
                [23.4, 2.4],
                [20.7, 22.02],
                [12.9, 28.08],
                [4.98, 34.26],
                [2.4, 24],
              ],
            },
          },
        },
        {
          ty: 'sh',
          bm: 0,
          hd: false,
          nm: 'Path 3',
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [4.08, 0],
                [3.24, 1.98],
                [1.8, 2.88],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [2.88, -1.74],
              ],
              o: [
                [-3.3, 1.98],
                [-4.08, 0],
                [-2.94, -1.74],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [-1.8, 2.94],
                [0, 0],
              ],
              v: [
                [35.16, 42.48],
                [24, 45.6],
                [12.84, 42.48],
                [5.7, 35.46],
                [12.84, 32.52],
                [24, 27.96],
                [35.16, 32.46],
                [42.36, 35.4],
                [35.16, 42.48],
              ],
            },
          },
        },
        {
          ty: 'sh',
          bm: 0,
          hd: false,
          nm: 'Path 4',
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [-3.06, -1.86],
                [0, -7.86],
                [1.68, -3.06],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [3.78, 0.12],
                [6.3, 3.78],
                [0, 3.72],
                [0, 0],
                [0, 0],
              ],
              v: [
                [35.16, 28.08],
                [27.42, 22.08],
                [24.66, 2.4],
                [35.1, 5.46],
                [45.6, 24],
                [43.02, 34.26],
                [35.16, 28.08],
              ],
            },
          },
        },
        {
          ty: 'gf',
          bm: 0,
          hd: false,
          nm: 'Gradient Fill',
          e: {
            a: 1,
            k: [
              { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [53, 48], t: 0 },
              { s: [86.5, 73], t: 119 },
            ],
          },
          g: {
            p: 4,
            k: {
              a: 0,
              k: [
                0, 1, 1, 1, 0.32692307233810425, 0.8941176470588236, 0.8941176470588236,
                0.8941176470588236, 0.4375, 0.6, 0.6, 0.6, 0.5817307829856873,
                0.9647058823529412, 0.9647058823529412, 0.9647058823529412,
              ],
            },
          },
          t: 1,
          a: { a: 0, k: 0 },
          h: { a: 0, k: 0 },
          s: {
            a: 1,
            k: [
              { o: { x: 0.33, y: 1 }, i: { x: 0.68, y: 1 }, s: [-55.5, -30.5], t: 0 },
              { s: [41.5, 41], t: 119 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 1,
    },
  ],
  v: '5.7.0',
  fr: 60,
  op: 120,
  ip: 0,
  assets: [],
};
export default function MercedesLogo(props: LottieProps) {
  return <LottieBase animationJSON={animationJSON} {...props} />;
}
